import { topicTags } from '@/pages/home/mocks/data';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            实时热度
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">热门话题</h2>
          <p className="text-foreground-500 mt-2 text-sm">当前最受关注的八卦话题，热度实时更新</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topicTags.map((tag) => (
            <a
              key={tag.id}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all hover:scale-105 cursor-pointer whitespace-nowrap ${colorMap[tag.color]}`}
            >
              <span>{tag.name}</span>
              <span className="text-xs opacity-70">{tag.heat}</span>
              {tag.trend === 'up' && <i className="ri-arrow-up-line text-xs text-green-600"></i>}
              {tag.trend === 'down' && <i className="ri-arrow-down-line text-xs text-red-500"></i>}
              {tag.trend === 'hot' && <i className="ri-fire-line text-xs text-primary-500"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}